import React, { Component } from 'react';
import { db } from '../firebase';
import withAuthorisation from '../components/withauthorisation';
import Dropdown from '../components/global/dropdown';
import List360 from '../components/list360';
import Modal from '../components/global/modal';
import Autocomplete from 'react-autocomplete';
import CreateNewProject from '../components/CreateNewProject';
import { clientSortOptionsList } from '../constants/staticVariables.js';
import { getClientItemListFilter, sortProjects } from '../helpers.js';
import ClientSelection from '../components/clientSelection.js';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});
const authCondition = (authUser) => !!authUser;

let btnBrandCol;

class TeamAssessmentProjects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      settingUpProject: false,
      noprojects: true,
      accountId: this.props.match.params.accountId,
      accountData: this.props.accountData,
      user360s: {},
      clientList: '',
      clientName: '',
      showNew360Modal: false,
      new360Type: 'Team Assessment',
      filteredByClient: null,
      sortedBy: 0,
    };

    this.createNew360 = this.createNew360.bind(this);
    this.closeNew360Modal = this.closeNew360Modal.bind(this);
    this.openNew360Modal = this.openNew360Modal.bind(this);
    this.fireClientFilter = this.fireClientFilter.bind(this);
    this.duplicate360 = this.duplicate360.bind(this);
    this.updateSortID = this.updateSortID.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    let clientList = {};
    let sortList = clientSortOptionsList;
    let archivedTeamAssessments = {};
    let activeTeamAssessments = {};
    let clientItemList = [];
    let activeGroupedByClient = {};

    db.doGet360s(this.state.accountId).then((snapshot) => {
      if (!snapshot.empty) {
        snapshot.docs.forEach(doc => {
          const { client } = doc.data();
          const docID = doc.id;
          const docData = doc.data();
          if (!clientList[client]) {
            clientList[client] = [];
          }
          clientList[client].push({...docData, projectID: docID})
        })
        // creates an array of child arrays, each child consists of the 360ID [0] and the data for that 360 [1]
        // then filters out any 360s that aren't of the Team Assessment type
        const filtered360s = snapshot.docs.map((doc) => [doc.id, doc.data()]).filter((data) => data[1].type === 'Team Assessment');
        let teamAssessments = {};
        let count = 0;
        filtered360s.forEach((tA) => {
          const id = tA[0];
          const data = tA[1];
          const clientName = data['client'];
          // adds each Assessment to the teamAssessmennt object
          teamAssessments[id] = data;
          // puts each Assessment in an archived or active object. Also adds active Assessments as children of clients in another object
          if (data['archived']) {
            archivedTeamAssessments[id] = data;
          } else {
            activeTeamAssessments[id] = data;
            if (!activeGroupedByClient[clientName]) {
              activeGroupedByClient[clientName] = {};
            }
            activeGroupedByClient[clientName][id] = data;
          }
        });
        
        // sorts clients alphabetically then adds them to filter object
        const orderedClientList = Object.keys(clientList).sort();

        let clientItemListFilter = getClientItemListFilter(orderedClientList);

        let user360s = {};
        snapshot.docs.map((doc) => {
          user360s[doc.id] = doc.data();
        });
        if (user360s) {
          this.setState({
            teamAssessments: teamAssessments,
            archivedTeamAssessments: archivedTeamAssessments,
            activeTeamAssessments: activeTeamAssessments,
            clientItemList: clientItemList,
            clientItemListFilter,
            orderedClientList,
            activeGroupedByClient: activeGroupedByClient,
            user360s: user360s,
            clientList: clientList,
            sortList,
            noprojects: false,
            loading: false,
          });
        } else {
          this.setState({
            noprojects: true,
            loading: false,
          });
        }
      } else {
        this.setState({
          noprojects: true,
          loading: false,
        });
      }
    });
  }

  closeNew360Modal() {
    this.setState({ showNew360Modal: false });
  }

  openNew360Modal(type) {
    this.setState({ showNew360Modal: true, new360Type: type });
  }

  createNew360(e) {
    db.doCreate360(this.state.accountId, this.title.value, this.state.clientName, this.state.new360Type, this.state.accountData)
      .then((data) => {
        let new360ID = data.id;
        this.setState({
          clientName: '',
        });
        db.doCreateNewQuestionnaire(this.state.accountId, this.state.new360Type).then((data) => {
          let newQuestionnaireID = data.id;
          db.doAssignQuestionnaireTo360(this.state.accountId, newQuestionnaireID, new360ID).then((data) => {
            db.addDefaultQuestionnaireLabels(this.state.accountId, newQuestionnaireID).then(() => {
              this.setState({
                settingUpProject: false,
              });
              this.closeNew360Modal();
              this.props.history.push(`/dashboard/${this.state.accountId}/360s/${new360ID}/edit/`);
            })
          });
        });
      })
      .catch((error) => {
        this.setState(byPropKey('error', error));
      });
    e.preventDefault();
  }

  fireClientFilter(id, key) {
    if (id === -1) {
      this.setState({
        filteredByClient: null,
      });
    } else {
      this.setState({
        filteredByClient: key,
      });
    }
  }

  duplicate360(accountID, title, index, comparisonCheck) {
    db.doDuplicate360(accountID, title, index, comparisonCheck)
      .then((new360ID) => {
        this.props.history.push(`/dashboard/${this.state.accountId}/360s/${new360ID}/edit/`);
      })
      .catch((err) => {});
  }

  updateSortID(id) {
    this.setState({sortedBy: id});
  }

  render() {
    const {clientItemListFilter, sortList, sortedBy, orderedClientList, loading} = this.state;
    let clientItemList = [];
    if (!loading) {
      orderedClientList.forEach((key, i) => {
        clientItemList.push({
          id: i,
          label: key,
        });
      })
    }
    return (
      <div className='container container--slim'>
        <section className='welcome'>
          <div className='container'>
            <div className='welcome__row'>
              <h1>
                <span>Your</span> Team Assessment Projects
              </h1>
            </div>
          </div>
        </section>
        {this.state.loading ? (
          <p>Loading</p>
        ) : (
          <section className='page-wrapper'>
            {this.state.activeTeamAssessments && Object.keys(this.state.activeTeamAssessments).length ? (
              <div>
                <ClientSelection accountData={this.props.accountData} clientItemListFilter={clientItemListFilter} fireClientFilter={this.fireClientFilter} sortList={sortList} updateSortID={this.updateSortID} containerClasses='mb3 justify-end' />

                {Object.keys(this.state.activeGroupedByClient)
                  .sort()
                  .map((key) => {
                    const currentClient = this.state.activeGroupedByClient[key];
                    return this.state.filteredByClient ? (
                      this.state.filteredByClient === key ? (
                        <div className='client-group' key={key}>
                          {Object.keys(currentClient)
                            .sort((a,b) => sortProjects(currentClient[a],currentClient[b],sortedBy))
                            .map((key) => {
                            return (
                              <List360
                                key={key}
                                index={key}
                                userDetails={this.props.userDetails}
                                selectedAccount={this.state.accountId}
                                accountTitle={this.state.accountTitle}
                                current360={this.state.teamAssessments[key]}
                                accountId={this.state.accountId}
                                duplicate360={this.duplicate360}
                              />
                            );
                          })}
                        </div>
                      ) : (
                        ''
                      )
                    ) : (
                      <div className='client-group' key={key}>
                        <p>
                          <strong>{key}</strong>
                        </p>
                        {Object.keys(currentClient)
                            .sort((a,b) => sortProjects(currentClient[a],currentClient[b],sortedBy))
                            .map((key) => {
                          return (
                            <List360
                              key={key}
                              index={key}
                              userDetails={this.props.userDetails}
                              selectedAccount={this.state.accountId}
                              accountTitle={this.state.accountTitle}
                              current360={this.state.teamAssessments[key]}
                              accountId={this.state.accountId}
                              duplicate360={this.duplicate360}
                            />
                          );
                        })}
                      </div>
                    );
                  })}
              </div>
            ) : (
              ''
            )}
            <div className='flex w-100 justify-center'>
              <CreateNewProject projectType='Team Assessment' containerClass='create-new-panel--team-assessment' openNew360Modal={this.openNew360Modal} />
            </div>
            {this.state.archivedTeamAssessments && Object.keys(this.state.archivedTeamAssessments).length ? (
              <div>
                <div className='mv4'>
                  <h1 className='mb2'>Archived Team Assessment projects</h1>
                  <p>These Team Assessment projects are currently archived, you are still able to view all the Reports associated to them</p>
                </div>
                {Object.keys(this.state.archivedTeamAssessments).map((key) => {
                  return <List360 key={key} index={key} current360={this.state.teamAssessments[key]} accountId={this.state.accountId} />;
                })}
              </div>
            ) : (
              ''
            )}
          </section>
        )}

        <Modal
          isOpen={this.state.showNew360Modal}
          contentLabel='Add a new Team Assessment'
          onClose={() => this.closeNew360Modal()}
          content={
            <div>
              <h2>Create a new Team Assessment project</h2>
              <form onSubmit={this.createNew360}>
                <label htmlFor='title' className='f6 b db mb2'>
                  Project Name
                </label>
                <input
                  required
                  ref={(input) => (this.title = input)}
                  aria-describedby='name-desc'
                  className='input-reset ba b--black-20 pa2 mb4 db w-100'
                  type='text'
                  placeholder='Name your Team Assessment'
                />
                {!this.props.accountData.clientname ? (
                  <label htmlFor='client' className='f6 b db mb2'>
                    Client
                  </label>
                ) : (
                  ''
                )}

                {this.state.showNew360Modal && !this.props.accountData.clientname ? (
                  <Autocomplete
                    ref={(el) => (this.client = el)}
                    items={clientItemList}
                    shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
                    getItemValue={(item) => item.label}
                    renderItem={(item, isHighlighted) => (
                      <div
                        key={item.id}
                        className='input-reset bb bl br b--black-20 pa2 db w-100'
                        style={{ background: isHighlighted ? 'lightgray' : 'white' }}
                        onMouseDown={(e) => e.preventDefault()}
                      >
                        {item.label}
                      </div>
                    )}
                    renderInput={(props) => (
                      <input
                        required
                        aria-describedby='client-desc'
                        {...props}
                        className='input-reset ba b--black-20 pa2 mb4 db w-100'
                        type='text'
                        placeholder='Select a Client, or create new'
                      />
                    )}
                    value={this.state.clientName}
                    onChange={(e) => this.setState({ clientName: e.target.value })}
                    onSelect={(value) => this.setState({ clientName: value })}
                    wrapperStyle={{
                      position: 'relative',
                      zIndex: '999',
                    }}
                    menuStyle={{
                      top: '100%',
                      left: 0,
                      position: 'absolute',
                    }}
                  />
                ) : (
                  <input
                    required
                    aria-describedby='client-desc'
                    ref={(el) => (this.client = el)}
                    defaultValue={this.props.accountData.clientname}
                    className='input-reset ba b--black-20 pa2 mb4 db w-100'
                    type={this.props.accountData.clientname ? `hidden` : `text`}
                    placeholder='Select a Client, or create new'
                  />
                )}
                <button className='btn' disabled={this.state.settingUpProject} type='submit'>
                  Submit
                </button>
              </form>
            </div>
          }
        />
      </div>
    );
  }
}

export default withAuthorisation(authCondition)(TeamAssessmentProjects);
